/* eslint-disable max-len */
import { RootState } from 'interfaces';
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state['feature/review'] || initialState;

export const selectReviews = createSelector([selectDomain], (ReviewState) => ReviewState.reviews);
export const selectReviewsLoader = createSelector([selectDomain], (ReviewState) => ReviewState.loading);
export const selectReviewsTotal = createSelector([selectDomain], (ReviewState) => ReviewState.total);
